import { formatNumber, terrainLabel, totalityDuration } from '../../utils'
import styles from './Tooltip.module.scss'

function formatLocalTime(utc) {
	if (!utc) return '—'

	const [hours, minutes, seconds] = utc.replace(' UTC', '').split(':').map(Number)

	const date = new Date(Date.UTC(2026, 7, 12, hours, minutes, seconds))

	return new Intl.DateTimeFormat('ca-ES', {
		timeZone: 'Europe/Madrid',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
	}).format(date)
}

export default function EclipseTooltip({ coords, data, loading, error, onClose, texts }) {
	if (!coords) return null

	const isTotal = data?.tipus === 'total'
	const duration = data ? totalityDuration(data.hores?.iniciTotalitat, data.hores?.finalTotalitat, texts) : null
	const hores = data?.hores
	const hiHaFinal = hores?.postaSol?.utc && hores?.postaSol?.utc > hores?.finalParcial?.utc

	if (error) {
		return (
			<div className={styles.container}>
				<header style={{ backgroundColor: '#fff' }}>
					{error === 'NO_DATA' ? texts.noData : texts.loadError}
					<button onClick={onClose} style={{ minWidth: '18px', minHeight: '18px' }}>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							height='18px'
							viewBox='0 -960 960 960'
							width='18px'
							fill='#000'
						>
							<path d='m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z' />
						</svg>
					</button>
				</header>
			</div>
		)
	}
	if (loading || error || !data) return null
	return (
		<div className={styles.container}>
			<header>
				{(data?.nomMunicipi || data?.town_name) && <b>{data.nomMunicipi || data.town_name}</b>}
				<button onClick={onClose} style={{ minWidth: '18px', minHeight: '18px' }}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						height='18px'
						viewBox='0 -960 960 960'
						width='18px'
						fill='#000'
					>
						<path d='m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z' />
					</svg>
				</button>
			</header>
			<div className={styles.contingut}>
				{data?.name && (
					<p>
						<span style={{ display: 'flex', gap: '6px' }}>
							<span className={styles.punts} />
							{data.name}
						</span>
						<a
							href={`https://www.google.com/maps/search/?api=1&query=${coords.pointLat ?? coords.lat},${coords.pointLng ?? coords.lng}`}
							target='_blank'
							rel='noopener noreferrer'
							style={{ minWidth: '18px', minHeight: '18px' }}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								height='18px'
								width='18px'
								viewBox='0 -960 960 960'
								fill='#000'
							>
								<path d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z' />
							</svg>
						</a>
					</p>
				)}

				<p>
					<span>{texts.start}</span>
					<span>{formatLocalTime(hores?.iniciParcial?.utc)} h</span>
				</p>
				<p className={styles.fons_gris}>
					<b>{data.obscuracioPercentatge === 100 ? texts.totalEclipse : texts.partialEclipse}</b>
					<b>{formatNumber(data.obscuracioPercentatge, 2)}%</b>
				</p>
				{isTotal && (
					<>
						<div className={styles.totalitat}>
							<p>
								<span>{texts.totalityStart}</span>
								<span>{formatLocalTime(hores?.iniciTotalitat?.utc)} h</span>
							</p>
							<p>
								<span>{texts.maximum}</span>
								<span>{formatLocalTime(hores?.maximEclipsi?.utc)} h</span>
							</p>
							<p>
								<span>{texts.totalityEnd}</span>
								<span>{formatLocalTime(hores?.finalTotalitat?.utc)} h</span>
							</p>
							<p>
								<span>{texts.duration}</span>
								<span>{duration ? duration : '-'}</span>
							</p>
						</div>
					</>
				)}

				<p>
					<span>{hiHaFinal ? texts.eclipseEnd : texts.sunset}</span>
					<span>{formatLocalTime(hiHaFinal ? hores?.finalParcial?.utc : hores?.postaSol?.utc)} h</span>
				</p>
			</div>

			{!hiHaFinal && <p className={styles.nota}>{texts.sunsetNote}</p>}
			{/* <p className={styles.nota}>{terrainLabel(data.visibilitatRelleu)}</p> */}
		</div>
	)
}
